import React, { Component } from 'react';
import './Page.css';
import './Referrals.css';

import { API_BASE } from '../config';

import Button from '../components/Button';
import Input from '../components/Input';
import Notification from '../components/Notification';

class Referrals extends Component {

  constructor(props) {
    super(props);

    this._getUser = this._getUser.bind(this);
    this._toggleReferral = this._toggleReferral.bind(this);

    this.state = {
      notification_text:"",
      referralInputHidden:true,
      user_id:localStorage.getItem('user_id'),
      user:{
        name:"",
        email:""
      },
      welcome_message:this.props.params.welcome || false
    };

  }

  componentDidMount() {

    this._getUser();

  }

  render() {

      return (
        <div>
          <Notification text={this.state.notification_text} />

          <div className='App-signIn Page Page-Wide clearfix'>
          
            <div className="Referrals">

                <h1>Really Simple Referral Program</h1>
                <p>Earn free months by getting others to sign up.</p>

                <div className="clearflex align-flex-start">
                  
                  <div className="half column" style={{textAlign:"left",paddingTop:"1em"}}>

                    <h2 style={{marginTop:"0"}}>👋 Hi, {this.state.user.first_name}</h2>
                    <p>You can earn free months for your store by referring others to create a store.</p>
                    <p><strong>Just make sure they sign up using your unique referral link (really.at/{this.state.user.referral_url}).</strong></p>
                    <p>You can choose to use your free months now or in the future, and if you have more than one store, you can spread free months across them as you see fit.</p>
                    
                  </div>

                  <div className="half column" style={{paddingTop:"1em"}}>
                    
                    <div className="clearflex">
                    <div className="calloutBox">
                      <p className="label">Free months</p>
                      <h3>{this.state.user.free_months || "0"}</h3>
                    </div>
                    </div>

                    <p>&nbsp;</p>

                    <div className="clearflex">
                    <div className="calloutBox">
                      <p className="label">Your unique referral link</p>
                      <h3>really.at/{this.state.referralInputHidden ? this.state.user.referral_url : <Input name="referral_url" value={this.state.user.referral_url} id={this.state.user.id} endpoint="users" onSave={function() { this._getUser(); this._toggleReferral(); }.bind(this)} /> }</h3>
                      <p className="label" style={{fontSize:".5em"}}><a onClick={this._toggleReferral}>({this.state.referralInputHidden ? "Customize your link" : "Cancel" })</a></p>
                    </div>
                    </div>

                  </div>

                </div>

            </div>
          </div>

        </div>
        
      );
  
  }

  _getUser() {
    var _this = this;

    var request = new Request(`${API_BASE}users/`+_this.state.user_id, {
      method: 'GET', 
      mode: 'cors',
      headers: new Headers({
        'Authorization': localStorage.getItem('token')
      })
    });

    fetch(request).then(function(response) {
      return response.json();
    }).then(function(json) {

      _this.setState({
        user:json
      });

    }).catch(function(ex) {
      console.log('parsing failed', ex);
    });
  }

  _toggleReferral() {
    this.setState({
      referralInputHidden:!this.state.referralInputHidden
    })
  }

}

export default Referrals;



// WEBPACK FOOTER //
// ./src/pages/Referrals.js